/** @format */

import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { ActivatedRoute, Router } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, FontAwesomeModule],
})
export class PaginatorComponent {
  _common = _common;
  @Input()
  length = 0;

  @Input()
  pageIndex = 0;

  @Input()
  pageSize = 10;

  @Output()
  page = new EventEmitter<PageEvent>();

  prevOffset = [2, 1];
  offset = [1, 2];
  @Input()
  unit = 'item_plural';

  @Input()
  scroll: HTMLDivElement;

  gotoPage = '';

  get pageCount(): number {
    return Math.ceil(this.length / this.pageSize);
  }
  get lastItem(): number {
    let i = (this.pageIndex + 1) * this.pageSize;
    if (i > this.length) {
      i = this.length;
    }
    return i;
  }

  constructor(private router: Router, private route: ActivatedRoute) {}
  ngOnInit() {}
  hasNext() {
    return (this.pageIndex + 1) * this.pageSize < this.length;
  }
  hasPrev() {
    return this.pageIndex > 0;
  }
  move(i: number) {
    this.pageIndex = i;
    this.fire();
  }
  prevPage() {
    if (!this.hasPrev()) return;
    this.pageIndex--;
    this.fire();
  }
  firstPage() {
    if (!this.hasPrev()) return;
    this.pageIndex = 0;
    this.fire();
  }
  nextPage() {
    if (!this.hasNext()) return;
    this.pageIndex++;
    this.fire();
  }
  lastPage() {
    if (!this.hasNext()) return;
    this.pageIndex = this.pageCount - 1;
    this.fire();
  }
  fire() {
    this.scroll?.scrollTo(0, 0);
    this.page.next({
      pageIndex: this.pageIndex,
      length: this.length,
      pageSize: this.pageSize,
    });
  }
  goto() {
    let page = parseInt(this.gotoPage);
    if (isNaN(page)) return;
    if (page < 1 || page > this.pageCount) return;
    this.move(page - 1);
  }
}
